import React, { useState } from 'react';
import './HomePage.scss';

interface Film {
  id: number;
  title: string;
  subtitle: string;
  imageUrl: string;
  videoUrl: string;
}

const films: Film[] = [
  {
    id: 1,
    title: 'Emma & James',
    subtitle: 'Countryside Manor Wedding',
    imageUrl: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=3840&q=95&fit=crop',
    videoUrl: 'https://player.vimeo.com/video/123456789',
  },
  {
    id: 2,
    title: 'Sarah & Michael',
    subtitle: 'Beach Ceremony',
    imageUrl: 'https://images.unsplash.com/photo-1606800052052-a08af7148866?w=3840&q=95&fit=crop',
    videoUrl: 'https://player.vimeo.com/video/123456789',
  },
  {
    id: 3,
    title: 'Jessica & Tom',
    subtitle: 'City Hall Wedding',
    imageUrl: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=3840&q=95&fit=crop',
    videoUrl: 'https://player.vimeo.com/video/123456789',
  },
  {
    id: 4,
    title: 'Laura & David',
    subtitle: 'Garden Estate',
    imageUrl: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=3840&q=95&fit=crop',
    videoUrl: 'https://player.vimeo.com/video/123456789',
  },
  {
    id: 5,
    title: 'Charlotte & Oliver',
    subtitle: 'Historic Castle',
    imageUrl: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=3840&q=95&fit=crop',
    videoUrl: 'https://player.vimeo.com/video/123456789',
  },
  {
    id: 6,
    title: 'Sophie & Daniel',
    subtitle: 'Lakeside Venue',
    imageUrl: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=3840&q=95&fit=crop',
    videoUrl: 'https://player.vimeo.com/video/123456789',
  },
];

interface HomePageProps {
  menuOpen: boolean;
}

const HomePage: React.FC<HomePageProps> = ({ menuOpen }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [videoPlaying, setVideoPlaying] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % films.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + films.length) % films.length);
  };

  const handlePlayClick = () => {
    setVideoPlaying(true);
  };

  const handleCloseVideo = () => {
    setVideoPlaying(false);
  };

  const currentFilm = films[currentIndex];

  return (
    <div className={`home-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="carousel">
        <div
          className="carousel__slide"
          style={{ backgroundImage: `url(${currentFilm.imageUrl})` }}
        >
          <button className="carousel__play" onClick={handlePlayClick} aria-label="Play video">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="40" r="39" stroke="white" strokeWidth="2" />
              <path d="M32 26L56 40L32 54V26Z" fill="white" />
            </svg>
          </button>

          <div className="carousel__info">
            <h2 className="carousel__title">{currentFilm.title}</h2>
            <p className="carousel__subtitle">{currentFilm.subtitle}</p>
          </div>

          <div className="carousel__social">
            <a href="YOUR_YOUTUBE_URL_HERE" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="YOUR_INSTAGRAM_URL_HERE" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="YOUR_FACEBOOK_URL_HERE" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="YOUR_TWITTER_URL_HERE" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="YOUR_VIMEO_URL_HERE" target="_blank" rel="noopener noreferrer" aria-label="Vimeo">
              <i className="fab fa-vimeo-v"></i>
            </a>
            <a href="YOUR_TIKTOK_URL_HERE" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <i className="fab fa-tiktok"></i>
            </a>
          </div>

          <button className="carousel__prev" onClick={prevSlide} aria-label="Previous slide">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M25 10L15 20L25 30" stroke="white" strokeWidth="2" />
            </svg>
          </button>

          <button className="carousel__next" onClick={nextSlide} aria-label="Next slide">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M15 10L25 20L15 30" stroke="white" strokeWidth="2" />
            </svg>
          </button>

          <div className="carousel__counter">
            {currentIndex + 1} / {films.length}
          </div>
        </div>
      </div>

      {videoPlaying && (
        <div className="video-modal" onClick={handleCloseVideo}>
          <button className="video-modal__close" onClick={handleCloseVideo} aria-label="Close video">
            ✕
          </button>
          <div className="video-modal__content" onClick={(e) => e.stopPropagation()}>
            <iframe
              src={`${currentFilm.videoUrl}?autoplay=1`}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title={currentFilm.title}
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
